var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet-body form" }, [
    _c("form", { staticClass: "form-horizontal", attrs: { role: "form" } }, [
      _c("div", { staticClass: "form-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-4 control-label" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm._f("trans")(
                        "production_reports.production_list.production_date"
                      )
                    ) +
                    ":\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c("date-picker", {
                    attrs: { time: false, "is-nullable": false },
                    model: {
                      value: _vm.formDate,
                      callback: function($$v) {
                        _vm.formDate = $$v
                      },
                      expression: "formDate"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 pl-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  disabled: !_vm.checkedRows.length || _vm.disabled
                },
                on: { click: _vm.assignDateToChecked }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("assign_team.assign_date_btn")) +
                    "\n          "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-4 control-label" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("assign_team.production_team_select")
                  ) + ":"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c("single-select", {
                    attrs: { checked: _vm.formTeam, options: _vm.teams },
                    on: {
                      input: function($event) {
                        _vm.formTeam = $event
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 pl-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  disabled:
                    !_vm.formTeam || !_vm.checkedRows.length || _vm.disabled
                },
                on: { click: _vm.assignTeamToChecked }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("assign_team.assign_team_btn")) +
                    "\n          "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "col-md-4 control-label" }, [
                _vm._v(
                  _vm._s(_vm._f("trans")("assign_team.unfolding_team_select")) +
                    ":"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c("single-select", {
                    attrs: {
                      checked: _vm.formUnfoldingTeam,
                      options: _vm.unfoldingTeams
                    },
                    on: {
                      input: function($event) {
                        _vm.formUnfoldingTeam = $event
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 pl-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  disabled:
                    !_vm.formUnfoldingTeam ||
                    !_vm.checkedRows.length ||
                    _vm.disabled
                },
                on: { click: _vm.assignUnfoldingTeamToChecked }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("assign_team.assign_team_btn")) +
                    "\n          "
                )
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "col-md-7" }, [
          _c("div", [
            _c("label", { staticClass: "mt-checkbox mt-checkbox-outline" }, [
              _c("p", { staticClass: "checkbox-text" }, [
                _vm._v("Zaznacz wszystkie")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isCheckedAll,
                    expression: "isCheckedAll"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.isCheckedAll)
                    ? _vm._i(_vm.isCheckedAll, null) > -1
                    : _vm.isCheckedAll
                },
                on: {
                  click: _vm.checkAll,
                  change: function($event) {
                    var $$a = _vm.isCheckedAll,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isCheckedAll = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isCheckedAll = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isCheckedAll = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "view-loader",
          {
            attrs: { loading: _vm.disabled, size: "100px", "show-content": "" }
          },
          _vm._l(_vm.mealRows, function(mealRow, index) {
            return _c("assign-team-meal-row", {
              key: index,
              ref: "assignTeamMealRow",
              refInFor: true,
              attrs: {
                meal: mealRow,
                "is-checked": _vm.checkedRows.includes(mealRow.mealId),
                teams: _vm.teams,
                "unfolding-teams": _vm.unfoldingTeams,
                hours: _vm.hours,
                disabled: _vm.disabled,
                "show-details": Boolean(true)
              },
              on: { check: _vm.checkMeal, assingteam: _vm.assignTeamByMeal }
            })
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f73710c", { render: render, staticRenderFns: staticRenderFns })
  }
}